import React, { useEffect } from "react";
import { useForm, useFieldArray } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { BellRingIcon, DollarSign } from "lucide-react";
import { petPackageSchema } from "../../schemas/petPackageFormSchema";

export default function PackageForm({
  mode = "view",
  defaultValues = {
    title: "",
    description: "",
    price: 0,
    pet_id: [],
    sound_id: [],
    pet_package_type: "",
  },
  onSubmit,
  onCancel,
}) {
  const {
    register,
    control,
    handleSubmit,
    watch,
    setValue,
    formState: { errors, isSubmitting },
  } = useForm({
    context: {
      defaultPrice: defaultValues?.price || 0,
    },
    resolver: yupResolver(petPackageSchema),
    defaultValues,
  });
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="space-y-6">
        <div>
          <label className="block text-sm font-medium mb-1">
            Title
            <span className="text-red-500">*</span>
          </label>
          <div className="relative">
            <input
              {...register("title")}
              readOnly={mode === "view"}
              className="px-3 py-2 border rounded w-full"
              placeholder="E.g., Package Title"
            />
          </div>
          {errors.name && (
            <p className="text-red-500 text-xs">{errors.name.message}</p>
          )}
        </div>

        <div>
          <label className="block text-sm font-medium mb-1">
            Description
            <span className="text-red-500">*</span>
          </label>
          <div className="relative">
            <textarea
              {...register("description")}
              readOnly={mode === "view"}
              className="px-3 py-2 border rounded w-full"
              placeholder="E.g., Description of the package"
            />
          </div>
          {errors.name && (
            <p className="text-red-500 text-xs">{errors.name.message}</p>
          )}
        </div>

        <div>
          <label className="block text-sm font-medium mb-1">
            Play SKU ID
            <span className="text-red-500">*</span>
          </label>
          <div className="relative">
            <input
              {...register("play_sku_id")}
              readOnly={mode === "view"}
              className="px-3 py-2 border rounded w-full"
              placeholder="E.g., Play Store SKU ID"
            />
          </div>
          {errors.name && (
            <p className="text-red-500 text-xs">{errors.name.message}</p>
          )}
        </div>

        <div>
          <label className="block text-sm font-medium mb-1">
            Apple SKU ID
            <span className="text-red-500">*</span>
          </label>
          <div className="relative">
            <input
              {...register("apple_sku_id")}
              readOnly={mode === "view"}
              className="px-3 py-2 border rounded w-full"
              placeholder="E.g., Apple Store SKU ID"
            />
          </div>
          {errors.name && (
            <p className="text-red-500 text-xs">{errors.name.message}</p>
          )}
        </div>

        <div>
          <label className="block text-sm font-medium mb-1">
            Package Type
            <span className="text-red-500">*</span>
          </label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <BellRingIcon className="h-5 w-5 text-gray-400" />
            </div>
            <select
              {...register("slug")}
              disabled={mode === "view"}
              className="pl-10 pr-3 py-2 border rounded w-full"
            >
              <option value="">Select Package Type</option>
              <option value="alert_customization">Alert</option>
              <option value="pet_package">Pet</option>
            </select>
          </div>
          {errors.slug && (
            <p className="text-red-500 text-xs">
              {errors.slug.message}
            </p>
          )}
        </div>

        <div>
          <label className="block text-sm font-medium mb-1">Price</label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <DollarSign className="h-5 w-5 text-gray-400" />
            </div>
            <input
              type="number"
              step="0.01"
              {...register("price")}
              readOnly={mode === "view"}
              className="pl-10 pr-3 py-2 border rounded w-full"
              placeholder="0.00"
            />
          </div>
          {errors.price && (
            <p className="text-red-500 text-xs">{errors.price.message}</p>
          )}
        </div>

        {mode !== "view" && (
          <>
            <div className="flex items-center space-x-2">
              <input
                type="checkbox"
                id="consent"
                {...register("consent")}
                disabled={mode === "view"}
                className="h-4 w-4 border border-gray-300 rounded"
              />
              <label htmlFor="consent" className="text-sm">
                I agree that I have updated the price in both Play store Console
                and Apple store console
              </label>
            </div>
            {errors.consent && (
              <p className="text-red-500 text-xs mt-1">
                {errors.consent.message}
              </p>
            )}
          </>
        )}

        {/* {watch("pet_package_type") && (
          <div>
            <label className="block text-sm font-medium mb-1">
              {mode === "view" ? "Selected" : "Select"}{" "}
              {watch("pet_package_type") === "alert" ? "Sound" : "Pet"}
              <span className="text-red-500">*</span>
            </label>
            <div className="relative">
              <Multiselect
                options={watch("pet_package_type") === "alert" ? sounds : pets}
                selected={
                  watch("pet_package_type") === "alert"
                    ? watch("sound_id") || []
                    : watch("pet_id") || []
                }
                onChange={(selected) => {
                  setValue(
                    watch("pet_package_type") === "alert"
                      ? "sound_id"
                      : "pet_id",
                    selected
                  );
                }}
                placeholder={
                  watch("pet_package_type") === "alert"
                    ? "Select Sounds"
                    : "Select Pets"
                }
                disabled={mode === "view"}
                labelKey="title"
                valueKey="_id"
                className="py-2 w-full"
              />
            </div>
            {errors.pet_package_type && (
              <p className="text-red-500 text-xs">
                {errors.pet_package_type.message}
              </p>
            )}
          </div>
        )} */}
      </div>
      {/* Action buttons */}
      <div className="px-6 py-4 border-t flex justify-end space-x-3">
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-2 border rounded-md text-gray-700 bg-white hover:bg-gray-50"
        >
          {mode === "view" ? "Close" : "Cancel"}
        </button>
        {mode !== "view" && (
          <button
            type="submit"
            disabled={isSubmitting}
            className="px-4 py-2 rounded-md text-white bg-primary hover:bg-primary-700"
          >
            {mode === "edit" ? "Save Changes" : "Send"}
          </button>
        )}
      </div>
    </form>
  );
}
